export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0-rc.0/static/v4/video/icon-sound-off-e1bdb83b58da06f4dc13db06559389eb.svg";